import { Portal } from "@chakra-ui/react";
import { useState } from "react";
import { useHistory, useLocation, useRouteMatch, Switch, Route, Redirect } from "react-router-dom";
import AddOrder from "./AddOrder";
import OrderList from "./OrderList";
import AdminNavbar from "components/Navbars/AdminNavbar";



const OrderContainer = () => {
  const history = useHistory();
  const location = useLocation();
  const match = useRouteMatch(); // e.g. /order
  const [editingCustomer, setEditingCustomer] = useState(null);

  // Detect current view from path
  const isAdd = location.pathname.endsWith("/add");
  const isEdit = location.pathname.includes("/edit");

  // ✨ Breadcrumbs logic
  const breadcrumbs = [
    {
      label: "Παραγγελίες",
      onClick: () => history.push(match.url),
      isClickable: isAdd || isEdit,
      isCurrent: !(isAdd || isEdit),
    },
    ...(isAdd || isEdit
      ? [
        {
          label: isEdit ? "ΚΑΤΑΣΤΑΣΗ" : "Παραγγελίες",
          isClickable: false,
          isCurrent: true,
        },
      ]
      : []),
  ];

  const handleAddClient = () => {
    history.push(`${match.url}/add`);
  };

  const handleEdit = (order) => {
    localStorage.setItem("orderData", JSON.stringify(order)); // Save to localStorage
    setEditingCustomer(order); // You may want to rename this to setEditingOrder
    history.push(`${match.url}/edit/${order.id}`);
  };


  const handleDelete = (order) => {
    console.log("Delete clicked for:", order);
  };

  const onOrderStatus = (status) => {
    if (status === true) {
      history.push(match.url);
    }
  };

  return (
    <>
      <Portal>
        <AdminNavbar logoText="ΚΡΕΑΡΙΣΤΟΝ" breadcrumbs={breadcrumbs} />
      </Portal>

      <Switch>
        <Route exact path={match.path}>
          <OrderList
            handleAddClient={handleAddClient}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />
        </Route>

        <Route exact path={`${match.path}/add`}>
          <AddOrder
            customerData={null}
            onOrderStatus={onOrderStatus}
          />
        </Route>

        <Route exact path={`${match.path}/edit/:id`}>
          <AddOrder
            customerData={
              editingCustomer || JSON.parse(localStorage.getItem("orderData"))
            }
            onOrderStatus={onOrderStatus}
          />
        </Route>


        {/* Fallback to order list for unknown routes */}
        <Redirect to={match.url} />
      </Switch>
    </>
  );
};

export default OrderContainer;
